<ion-header class="ion-no-border" class="details-screen" mode="ios">
  <ion-toolbar class="ion-no-padding">
    <ion-img *ngIf="showLogo" slot="start" [alt]="logoAltName" [src]="logo" (click)="goHome()"></ion-img>
    <ion-buttons>
      <ion-button color="primary" expand="block" mode="md" (click)="closePage.emit()">
        <fa-icon slot="start" size="lg" [icon]="icon"></fa-icon>
        <ion-text>Back</ion-text>
      </ion-button>
    </ion-buttons>
    <div slot="primary">
      <ng-content select="[slot=button]"></ng-content>
    </div>
  </ion-toolbar>
</ion-header>
